<template>
    <div>
        <div>{{ userName }}</div>
        <div style="margin-top: 0.2rem;">
            <el-button size="mini" type="primary" @click="getUserName">获取姓名</el-button>
        </div>
        <!-- <div style="margin-top: 0.2rem;">
            <el-button size="mini" type="primary" @click="getUserName1">getName</el-button>
        </div> -->
    </div>
</template>
<script>
import hr from '../../authShowConfig/axios'
export default {
    name: 'WorkWeiXinAuthShow',
    data() {
        return {
            'userName': ''
        }
    },
    methods: {
        // getUrl(){
        //     this.$axios.get('api/workWeixinRedirectUri').then().catch()
        // },
        getCode() {
            // console.log('code is:' + this.$route.query.code)
            if (localStorage.authShowToken) return false
            console.log('token已重新获取!')
            const code = this.$route.query.code
            if (code) {
                this.getUserInfo(code)
            }
        },
        getUserInfo(code) {
            this.$axios.get('api/third_work_weixin_get_user_info', {
                params: {
                    code
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    localStorage.setItem('authShowToken', data.token)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getUserName() {
            hr.get('api/auth_show_get_name').then(({ data }) => {
                if (data.code === 200) {
                    this.userName = data.name
                }
            }).catch()
        },
        getUserName2() {
            const instance = this.$axios.create({
                // baseURL: 'https://some-domain.com/api/',
                // timeout: 1000,
                headers: { 'authShowToken': localStorage.getItem('authShowToken') }
            });

            // instance.interceptors.request.use(function (config) {
            //     // 使用qs 来处理post的参数
            //     config.data = qs.stringify(config.data)
            //     return config
            // })

            instance.interceptors.response.use(function (res) {
                console.log(res)
                if (res.code === 400) {
                    this.$message.error(res.msg)
                } else if (res.code === 401) {
                    this.$message.error(res.msg)
                }
            })

            instance.get('api/auth_show_get_name').then(({ data }) => {
                if (data.code === 200) {
                    this.userName = data.name
                }
            }).catch()
        },
        getUserName1() {
            const instance = this.$axios.create({
                // baseURL: 'https://some-domain.com/api/',
                // timeout: 1000,
                headers: { 'authShowToken': localStorage.getItem('authShowToken') }
            });

            // instance.interceptors.request.use(function (config) {
            //     // 使用qs 来处理post的参数
            //     config.data = qs.stringify(config.data)
            //     return config
            // })

            instance.interceptors.response.use(function (res) {
                console.log(res)
                if (res.code === 400) {
                    this.$message.error(res.msg)
                } else if (res.code === 401) {
                    this.$message.error(res.msg)
                }
            })

            this.$axios.get('api/auth_show_get_name').then(({ data }) => {
                if (data.code === 200) {
                    this.userName = data.name
                }
            }).catch()
        }
    },
    mounted() {
        // this.getUrl()
        this.getCode()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/ysy/WorkWeiXinAuthShow.vue